import React from 'react';
import { FeaturedCarousel } from '../FeaturedCarousel';
import { MustReads } from '../MustReads';
import { ActivityFeed } from '../ActivityFeed';
import { RightRail } from '../RightRail';
import { RateWatch } from '../RateWatch';
import { useApp } from '../store';
export function HomePage() {
  const {
    config
  } = useApp();
  const {
    welcome,
    modules
  } = config;
  return <>
      <div className="mb-6 rounded-2xl bg-navy-600 px-6 py-8 sm:px-10 sm:py-10 text-white overflow-hidden relative" data-id="element-450">
        <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-gold-500/10" aria-hidden="true" data-id="element-451" />
        <div className="pointer-events-none absolute -right-8 bottom-0 h-40 w-40 rounded-full bg-gold-500/5" aria-hidden="true" data-id="element-452" />
        <div className="relative" data-id="element-453">
          {welcome.eyebrow && <p className="text-gold-400 text-xs font-semibold uppercase tracking-[0.2em]" data-id="element-454">
              {welcome.eyebrow}
            </p>}
          <h1 className="mt-2 text-3xl sm:text-4xl font-serif font-bold leading-tight" data-id="element-455">
            {welcome.heading}
          </h1>
          {welcome.subtext && <p className="mt-2 max-w-xl text-navy-100 text-sm sm:text-base" data-id="element-456">
              {welcome.subtext}
            </p>}
        </div>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-[1fr_340px] gap-6" data-id="element-457">
        <div className="space-y-6 min-w-0" data-id="element-458">
          <FeaturedCarousel data-id="element-459" />
          {modules.mustReads && <MustReads data-id="element-460" />}
          <ActivityFeed compact data-id="element-461" />
        </div>
        <div className="xl:block space-y-6" data-id="element-462">
          {modules.rateWatch && <RateWatch data-id="element-463" />}
          <RightRail data-id="element-464" />
        </div>
      </div>
    </>;
}